export const investmentProducts = [
  {
    id: 1,
    category: "UK Structured Product",
    badge: "Flagship",
    badgeColor: "#C9A84C",
    name: "Social Housing Structured Product",
    description: "Asset-backed, income-generating investment secured by UK assisted living properties. Long-term housing association leases with assured income and no void periods.",
    targetReturn: "10.00% p.a.",
    term: "5 Years",
    frequency: "Monthly",
    currency: "GBP",
    minInvestment: "£10,000",
    rating: "First Legal Charge",
    listing: "Private Placement",
    status: "Open",
    icon: "ri-building-2-line",
    link: "/social-housing",
    highlights: ["First legal charge security", "FRI lease structure", "CPI + 1% rent increases", "No void periods"],
  },
  {
    id: 9,
    category: "UK Structured Product",
    badge: "Conservative",
    badgeColor: "#C9A84C",
    name: "UK Commercial Property Income Fund",
    description: "Diversified portfolio of UK commercial properties including logistics warehouses, medical centres and retail parks. Focus on long-dated leases to investment-grade tenants.",
    targetReturn: "7.00% p.a.",
    term: "5 Years",
    frequency: "Semi-Annual",
    currency: "GBP",
    minInvestment: "£50,000",
    rating: "Senior Secured",
    listing: "Private Placement",
    status: "Open",
    icon: "ri-store-3-line",
    link: "/contact",
    highlights: ["Diversified portfolio", "Investment-grade tenants", "Logistics & healthcare focus", "Lower volatility profile"],
  },
  {
    id: 2,
    category: "NASDAQ Dubai",
    badge: "Listed",
    badgeColor: "#7B9EB8",
    name: "Dubai Government Sukuk",
    description: "AAA-rated sovereign Sukuk issued by the Government of Dubai, listed on NASDAQ Dubai. USD-denominated with semi-annual profit distributions.",
    targetReturn: "4.75% p.a.",
    term: "7 Years",
    frequency: "Semi-Annual",
    currency: "USD",
    minInvestment: "$10,000",
    rating: "AAA / Moody\'s Aa2",
    listing: "NASDAQ Dubai",
    status: "Open",
    icon: "ri-bank-line",
    link: "/contact",
    highlights: ["Sovereign-backed instrument", "NASDAQ Dubai listed", "USD denominated", "Sharia compliant"],
  },
  {
    id: 3,
    category: "NASDAQ Dubai",
    badge: "Investment Grade",
    badgeColor: "#7B9EB8",
    name: "Emirates NBD Fixed Income",
    description: "Senior unsecured notes issued by Emirates NBD, one of the UAE\'s largest banks. Investment grade rated with strong institutional backing.",
    targetReturn: "5.50% p.a.",
    term: "5 Years",
    frequency: "Semi-Annual",
    currency: "USD",
    minInvestment: "$25,000",
    rating: "A- / Fitch",
    listing: "NASDAQ Dubai",
    status: "Open",
    icon: "ri-secure-payment-line",
    link: "/contact",
    highlights: ["UAE banking sector", "Investment grade rated", "Institutional quality", "Secondary market liquidity"],
  },
  {
    id: 4,
    category: "DFM Listed",
    badge: "Sovereign",
    badgeColor: "#C9A84C",
    name: "Abu Dhabi Government Bonds",
    description: "USD-denominated bonds issued by the Emirate of Abu Dhabi. Backed by one of the world\'s most financially robust sovereign entities with vast sovereign wealth.",
    targetReturn: "4.20% p.a.",
    term: "10 Years",
    frequency: "Semi-Annual",
    currency: "USD",
    minInvestment: "$50,000",
    rating: "AA / S&P",
    listing: "DFM / Euroclear",
    status: "Open",
    icon: "ri-government-line",
    link: "/contact",
    highlights: ["Abu Dhabi sovereign issuer", "AA rated by S&P", "Global clearing via Euroclear", "Capital preservation focus"],
  },
  {
    id: 5,
    category: "NASDAQ Dubai",
    badge: "Corporate",
    badgeColor: "#7B9EB8",
    name: "DP World Sukuk 2029",
    description: "Sukuk issued by DP World, one of the world\'s largest port operators. Sharia-compliant structure backed by global logistics and infrastructure assets.",
    targetReturn: "5.625% p.a.",
    term: "5 Years",
    frequency: "Semi-Annual",
    currency: "USD",
    minInvestment: "$25,000",
    rating: "BBB+ / S&P",
    listing: "NASDAQ Dubai",
    status: "Limited",
    icon: "ri-ship-line",
    link: "/contact",
    highlights: ["Global port operator", "Infrastructure backed", "Sharia compliant", "NASDAQ Dubai listed"],
  },
  {
    id: 6,
    category: "DFM Listed",
    badge: "Real Estate",
    badgeColor: "#C9A84C",
    name: "Emaar Properties Sukuk",
    description: "Sukuk issued by Emaar Properties, developer of the Burj Khalifa and Dubai Downtown. Backed by a diversified portfolio of premium real estate assets.",
    targetReturn: "6.375% p.a.",
    term: "7 Years",
    frequency: "Semi-Annual",
    currency: "USD",
    minInvestment: "$25,000",
    rating: "BB+ / Fitch",
    listing: "DFM / NASDAQ Dubai",
    status: "Open",
    icon: "ri-building-4-line",
    link: "/contact",
    highlights: ["Burj Khalifa developer", "UAE real estate backed", "Premium asset portfolio", "High yield potential"],
  },
];
